import * as yup from "yup";
import { AddressSchema, addressDefaultValues } from "./address";

export const PaymentMethodSchema = yup.object().shape({
	number: yup.string().required("Card number is required"),
	nameOnCard: yup.string().required("Name on card is required"),
	expMonth: yup.string().required("Expiry month is required"),
	expYear: yup.string().required("Expiry year is required"),
	cvv: yup.string().required("CVV Code is required"),
});

export const PaymentMethodDefaultValues = {
	number: "",
	expMonth: "",
	expYear: "",
	cvv: "",
	nameOnCard: "",
};

export const PaymentSchema = yup.object().shape({
	addNewCard: yup.boolean(),
	selectPaymentMethod: yup.boolean(),
	paymentMethodId: yup.string().when("selectPaymentMethod", {
		is: true,
		then: yup.string().required("Please select a payment method"),
	}),
	card: yup.object().when("addNewCard", {
		is: true,
		then: PaymentMethodSchema,
	}),
	address: AddressSchema,
});

export const PaymentCardSchema = yup.object().shape({
	card: PaymentMethodSchema,
});

export const paymentDefaultValues = {
	addNewCard: false,
	selectPaymentMethod: true,
	card: PaymentMethodDefaultValues,
	address: addressDefaultValues,
	paymentMethodId: "",
};
